import { VStack } from '@chakra-ui/react'
import { WithToolsConfig } from '@editor/interfaces/editor'

import ToolActions from './ToolActions'
import VertexToolbar from './VertexToolbar'

const ToolSubtoolbar = ({ toolsConfig }: WithToolsConfig) => (
  <VStack position="absolute" bottom="50px" left="50%" transform="translateX(-50%)" zIndex={10} gap={6}>
    <ToolActions toolsConfig={toolsConfig} />
    <VertexToolbar />
  </VStack>
)

export default ToolSubtoolbar
